// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a753e29a36742fec4436","500":"d9dbc979bd3d1f75c79d"}[chunkId] + ".bundle.js";
};